import { PRODUCT_DETAIL_NOTIFICATION_SET_MESSAGE } from '../constants';

export const productDetailNotification = (
    state = {
        message: "",
        type: "",
    },
    action
) => {
    switch (action.type) {
        case PRODUCT_DETAIL_NOTIFICATION_SET_MESSAGE:
            return {
                ...state,
                ...action.payload,
            };
        default:
            return state;
    }
};
